import { render, staticRenderFns } from "./CategoryModalForm.vue?vue&type=template&id=56bf7328"
import script from "./CategoryModalForm.vue?vue&type=script&lang=js"
export * from "./CategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports